var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDeletedUserAvatar = function SvgDeletedUserAvatar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3487_187474)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 1080,
    fill: "#1A1A1F"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter0_f_3487_187474)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1308.5,
    cy: -264.5,
    r: 627.5,
    fill: "url(#paint0_linear_3487_187474)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    filter: "url(#filter1_f_3487_187474)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 170.5,
    cy: 1458.5,
    r: 627.5,
    fill: "url(#paint1_linear_3487_187474)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M714.5 889C786.78 889 845.375 830.405 845.375 758.125C845.375 685.845 786.78 627.25 714.5 627.25C642.22 627.25 583.625 685.845 583.625 758.125C583.625 830.405 642.22 889 714.5 889ZM779.938 736.312H649.062V779.938H779.938V736.312Z",
    fill: "#FF3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.582 394.59C394.582 314.279 459.687 249.174 539.998 249.174C620.31 249.174 685.415 314.279 685.415 394.59C685.415 474.902 620.31 540.007 539.998 540.007C459.687 540.007 394.582 474.902 394.582 394.59ZM320.842 640.765C348.112 613.494 385.1 598.174 423.667 598.174H644.634C583.039 625.116 540 686.594 540 758.125C540 784.076 545.665 808.705 555.826 830.84H307.333C291.271 830.84 278.25 817.819 278.25 801.757V743.59C278.25 705.024 293.571 668.036 320.842 640.765ZM798.734 814.668C791.351 820.883 783.271 826.297 774.629 830.775C785.216 830.07 794.253 823.699 798.734 814.668ZM654.497 830.84H605.668C591.745 810.043 583.625 785.032 583.625 758.125C583.625 750.693 584.244 743.406 585.435 736.313C592.356 777.567 618.577 812.277 654.497 830.84ZM779.938 736.313V692.688H649.062V736.313H779.938Z",
    fill: "#FF3E3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3487_187474",
    x: 181,
    y: -1392,
    width: 2255,
    height: 2255,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_3487_187474"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3487_187474",
    x: -957,
    y: 331,
    width: 2255,
    height: 2255,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 250,
    result: "effect1_foregroundBlur_3487_187474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3487_187474",
    x1: 1308.5,
    y1: -892,
    x2: 1308.5,
    y2: 363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6AE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3487_187474",
    x1: 170.5,
    y1: 831,
    x2: 170.5,
    y2: 2086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6AE6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3487_187474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 1080,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDeletedUserAvatar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/deleted-user-avatar.87a70f0131e15d7e717d91961bd7817f.svg";